import React from 'react'
import { hexColors } from '@mobi/settings/hexColors'
import { Icon } from '@mobi/component-library/Assets/Icon'
import {
  BettableTips,
  type Props as BettableTipsProps,
} from '@core/Areas/Racing/Components/BettableTips/BettableTips'
import { useTipsterDisplay } from '@core/Areas/Racing/Hooks/useTipsterDisplay'
import { ExpandablePanelThemes } from '@core/Components/ExpandablePanel/themes'
import { CompactPanel } from '@core/Components/Panel'
import { Text } from '@core/Components/Text'

type Props = BettableTipsProps & {
  tipster: string
}

export const BettableTipsPanel = ({
  tipster,
  tips,
  isRaceOpen,
  raceKey,
  race,
}: Props): JSX.Element => {
  const tipsterDisplay = useTipsterDisplay(tipster)

  return (
    <CompactPanel
      themeName={ExpandablePanelThemes.lavender}
      headerText={<Text data-testid='bettable-tips-header-text'>{tipsterDisplay} Tips</Text>}
      headerIcon={<Icon name='SolidStar01' size='1.8rem' color={hexColors.blueDiamond} />}
    >
      <BettableTips
        tips={tips}
        race={race}
        raceKey={raceKey}
        isRaceOpen={isRaceOpen}
        tipSource='tips'
      />
    </CompactPanel>
  )
}
